import React from "react";
import { Modal, Typography, Alert, Divider } from "antd";

import "./LocationAccess.css"; // Custom CSS for styling

const { Text } = Typography;

const LocationInfoModal = ({ isVisible, handleCancel }) => {
  return (
    <Modal
      className="location-modal"
      title={<div className="modal-title">Usage of Location in Login</div>}
      open={isVisible}
      footer={null}
      centered
      width={720}
      onCancel={handleCancel}
    >
      <div className="modal-content">
        <Alert
          description={
            <>
              <Text className="text-loc-modal">
                If you turn this feature on, Then all the accounts created from
                this organization would require location access from their
                browser.
              </Text>
              <Divider style={{ margin: "5px" }} />

              <Text className="text-loc-modal">
                If the access for location is not given the users will not be
                allowed to login.
              </Text>
              <Divider style={{ margin: "5px" }} />

              <Text className="text-loc-modal">
                When the access is allowed Trainery checks for the previous
                logged in locations, If the login is attempted from a diffrent
                region then OTP verification is required.
              </Text>
            </>
          }
          type="info"
          showIcon
        />
      </div>
    </Modal>
  );
};

export default LocationInfoModal;
